import { DispensationProperties } from '@memed/x-ray-tracker-js/types/context';
import { BaseProperties } from '@monitoring/types';
import { trackEvent } from '../x-ray-tracker';
import { eventAction, eventLabel, interactionEventPages } from './dispensation-home';

export interface TrackInteractionParams {
  pageName: keyof typeof interactionEventPages;
  properties?: DispensationProperties;
}

type Properties = BaseProperties & {
  prescription_id: string;
  item_id: string;
  type: string;
  quantity: string;
  announcement_id: string;
  can_dispense_partial?: string;
  partially_dispensed_itens?: string;
}

interface InteractionProperties {
  page: string;
  category: string;
  action: eventAction;
  label: eventLabel;
  properties: Partial<Properties>;
}

const eventName = 'interaction';

const baseProperties: Pick<InteractionProperties, 'category'> = {
  category: 'dispensador',
}

export function trackInteraction({
  properties,
  ...rest
}: InteractionProperties): boolean {
  const mergedProperties = {
    ...baseProperties,
    ...properties,
    ...rest,
  }


  return trackEvent(eventName, rest.page, mergedProperties);
}